export default __webpack_public_path__ + "static/media/GroupMBG.f9d4f898.png";